// Constants
import { WELCOME_RULE_LIST } from "constants/navigation/info";

// Hooks
import useTranslate from "hooks/useTranslate";

// Types
import { WelcomeBonusCurrencyBlockValues } from "types/WelcomeBonus";

import "./styles.sass";

interface IWelcomeBonusInfoRiles {
  currencyValues: WelcomeBonusCurrencyBlockValues;
}

const WelcomeBonusInfoRules: React.FC<IWelcomeBonusInfoRiles> = ({
  currencyValues,
}) => {
  const t = useTranslate();

  return (
    <div className="WelcomeBonusInfoRules">
      <span className="WelcomeBonusInfoRules__header">
        {t("info.promo.welcome.terms")}
      </span>
      <div className="WelcomeBonusInfoRules-list">
        {WELCOME_RULE_LIST.map((item, index) => (
          <div className="WelcomeBonusInfoRules-list-block" key={item.title}>
            <div className="WelcomeBonusInfoRules-list-block-header">
              <div className="WelcomeBonusInfoRules-list-block-header__icon">
                {item.img}
              </div>
              <span className="WelcomeBonusInfoRules-list-block-header__title">
                {t(item.title)}
              </span>
            </div>
            <div className="WelcomeBonusInfoRules-list-block__hr" />
            <div>
              <span className="WelcomeBonusInfoRules-list-block__desc">
                {t(item.description_first)}{" "}
                {index === 0 && currencyValues && currencyValues.block4[0]}{" "}
                {index === 1 && currencyValues && currencyValues.block5}{" "}
                {t(item.description_second)}{" "}
                {index === 0 && currencyValues && currencyValues.block4[1]}{" "}
                {t(item.description_third)}
              </span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default WelcomeBonusInfoRules;
